// extracted by mini-css-extract-plugin
export var markdown = "_vl-0";
export var tableWrapper = "_vl-1";